export const prompt = {
    noData: 'No matched data',
};
